// This file is auto-generated by dibs-icons script
import { FC } from 'react';
import Bolt20 from './Bolt20';
import Bolt20Filled from './Bolt20Filled';
import Bolt20CircleFilled from './Bolt20CircleFilled';
import Bolt24 from './Bolt24';
import Bolt24Filled from './Bolt24Filled';
import Bolt24CircleFilled from './Bolt24CircleFilled';

type BoltProps = {
    size?: number;
    circle?: boolean;
    filled?: boolean;
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Bolt20,
    Bolt20Filled,
    Bolt20CircleFilled,
    Bolt24,
    Bolt24Filled,
    Bolt24CircleFilled,
};

const Bolt: FC<BoltProps> = ({ size = 20, circle = false, filled = true, ...props }) => {
    const variationKey = `Bolt${size}${circle ? 'Circle' : ''}${
        filled ? 'Filled' : ''
    }` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    return <Icon {...props} />;
};

export default Bolt;
